interface IEvents {
  readonly chatbotStateChanged: import('../../server/service/InitialChatData').IInitialChatData;
  readonly reloadChat: undefined;
  readonly updateArticleUri: string;
  readonly updateArticleId: string;
  readonly updateCategoryUri: string;
  readonly openHomePage: string;
  readonly openChatbotPage: undefined;
  readonly openSearchPage: string;
}

type TKeys = keyof IEvents;
type TCallback<K extends TKeys> = (payload: IEvents[K]) => void;

interface IEmitter {
  readonly emit: <K extends TKeys>(event: K, payload: IEvents[K]) => void;
  readonly on: <K extends TKeys>(event: K, cb: TCallback<K>) => void;
  readonly remove: <K extends TKeys>(event: K) => void;
  readonly removeListener: <K extends TKeys>(event: K, subscriber: TCallback<K>) => void;
}

const createEmitter = (): IEmitter => {
  const events = new Map<TKeys, TCallback<TKeys>[]>();

  const ensure = (event: TKeys) => (events.has(event) ? events.get(event) : events.set(event, []).get(event));

  return {
    emit(event, payload) {
      ensure(event)?.forEach((cb) => cb(payload));
    },

    on(event, cb) {
      ensure(event)?.push(cb);
    },

    // note: it will remove all subscription for this event
    remove(event) {
      events.delete(event);
    },

    removeListener(event, listener) {
      const filteredSubscriptions = ensure(event)?.filter((sub) => sub !== listener);

      if (filteredSubscriptions) {
        events.set(event, filteredSubscriptions);
      }
    },
  };
};

export const emitter = createEmitter();
